import AppHeader from "../../components/app/Header";
import Footer from "../../components/app/footer";
import { toastr } from 'react-redux-toastr';
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
const HeadContent = dynamic(() => import('../../hoc/headContent'), { loading: () => <></>, ssr: true });

// starting redux stuff ...
import store from '../../store';
import { createWrapper } from 'next-redux-wrapper';
// ending redux stuff ...

// import "./style.scss";
import MobileHeader from "../../components/static/mobileHeader";
// import AppMobileHeader from "../../components/app/mobileHeader";

function AppLayout(props) {
	const { userAuth } = store.getState();
	// const [href, setHref] = useState("");

	useEffect(() => {
		// setHref(window.location.href);
		if (!userAuth.token) {
			toastr.info("Sorry!", "Please login to access application page.");
			window.location.href = '/login';
		} else if (!userAuth.authenticated ) {
			toastr.info("Sorry!", "Please verify your email.");
			window.location.href = '/email-verification';
		}
	}, []);
	
	return (
		<>
			<HeadContent
				title={props.meta.title}
				description={props.meta.description}
				route={props.meta.route}
				image_url={props.meta.image_url}
			/>
				<div className="app-layout">
					<AppHeader theme={props.theme} />

					<MobileHeader theme={props.theme} />
				{/* <AppMobileHeader theme={props.theme} /> */}
					
					<div className="app-content">
							{props.children}
					</div>
				{/* {(href.indexOf("chat") > -1) ? <></> : <Footer />} */}

				
				<Footer />
				{/* Code For Donation */}
				<a id="donation-custom-btn" href="#XCURMUKD" style={{ display: 'none' }}></a>
				</div>
		</>
	);
}

const makeStore = () => store;
const wrapper = createWrapper(makeStore);

export default wrapper.withRedux(AppLayout);
